//#region src/detectPlatform.ts
function e() {
	return typeof navigator < "u" && navigator.product === "ReactNative" ? "native" : "web";
}
//#endregion
export { e as detectPlatform };
